import {DateTime} from 'luxon';

export class TimeHelper {
  /**
   *
   * @param start
   * @param end
   * @param date
   */
  public static isDateBetween(start: DateTime | string, end: DateTime | string, date: DateTime | string): boolean {
    start = TimeHelper.getDateTime(start);
    end = TimeHelper.getDateTime(end);
    date = TimeHelper.getDateTime(date);

    return date >= start && date <= end;
  }

  public static isSame(dateA: DateTime, date: DateTime): boolean {
    return true;
  }

  public static getDateString(date: string | DateTime | Date): string {
    if(!date) {
      return null;
    }

    if(typeof date === 'string') {
      return date.substring(0, 10);
    }

    if(date instanceof Date) {
      return DateTime.fromJSDate(date).toISODate();
    }

    return date.toISODate();
  }

  /**
   * Formats a time value as HH:mm. Accepts ISO datetimes (mobile) as well as
   * time-only strings such as "08:30:00" (server/web); returns null when unparsable.
   * @param time
   */
  public static getTimeString(time: string | DateTime | Date): string {
    if(!time) {
      return null;
    }
    const dateTime = TimeHelper.getDateTime(time);
    return dateTime?.isValid ? dateTime.toFormat('HH:mm') : null;
  }

  public static getDateTime(date: string | DateTime | Date): DateTime {
    if(typeof(date) === 'string' && date) {
      return DateTime.fromISO(date);
    }
    else if(date instanceof Date) {
      return DateTime.fromJSDate(date);
    }
    return date as DateTime;
  }

  public static getDateAndTime(
    date: DateTime | string | Date,
    time: DateTime | string | Date
  ): DateTime {
    const _date = date instanceof Date
      ? DateTime.fromJSDate(date)
      : typeof date === 'string'
        ? DateTime.fromISO(date)
        : date;

    const _time = time instanceof Date
      ? DateTime.fromJSDate(time)
      : typeof time === 'string'
        ? DateTime.fromISO(time)
        : time;

    return _date.set({
      hour: _time.hour,
      minute: _time.minute,
      second: _time.second,
      millisecond: _time.millisecond
    });
  }

}
